
import { categories, operators, allBracketsSyntaxes, keywords, operatorList } from "../../constants.ts";

export default (mathTree: any[]) => {

	const recursiveRender = (tree: any[], { outerElement = false } = {}) => {

		const fragment = new DocumentFragment();

		for (const [expressionIndex, expression] of tree.entries()) {
			const expressionFragment = new DocumentFragment();

			for (const item of expression) {
				switch (item.category) {
					case (categories.operator): {
						switch (item.operator) {
							case (operators.fraction): {
								expressionFragment.append(
									<mfrac>
										{recursiveRender(item.numerator)}
										{recursiveRender(item.denominator)}
									</mfrac>
								);
								break;
							}
							case (operators.power): {
								if (item.base[0]?.[0]?.operator === operators.index) {
									expressionFragment.append(
										<msubsup>
											{recursiveRender(item.base[0][0].base)}
											{recursiveRender(item.base[0][0].index)}
											{recursiveRender(item.exponent)}
										</msubsup>
									);
								} else {
									expressionFragment.append(
										<msup>
											{recursiveRender(item.base)}
											{recursiveRender(item.exponent)}
										</msup>
									);
								}
								break;
							}
							case (operators.factorial): {
								expressionFragment.append(
									<mrow>
										{recursiveRender(item.expression)}
										<mo>!</mo>
									</mrow>
								);
								break;
							}
							case (operators.index): {
								expressionFragment.append(
									<msub>
										{recursiveRender(item.base)}
										{recursiveRender(item.index)}
									</msub>
								);
								break;
							}
							case (operators.root): {
								expressionFragment.append(
									<mroot>
										{recursiveRender(item.degree)}
										{recursiveRender(item.radicand)}
									</mroot>
								);
								break;
							}
							case (operators.squareRoot): {
								expressionFragment.append(
									<msqrt>{recursiveRender(item.radicand)}</msqrt>
								);
								break;
							}
							case (operators.sum): {
								expressionFragment.append(
									<mrow>
										<munderover>
											{/* ∑ */}
											<mo>&#x2211;</mo>
											{recursiveRender(item.startExpression)}
											{recursiveRender(item.endExpression)}
										</munderover>
										{recursiveRender(item.expression)}
									</mrow>
								);
								break;
							}
							case (operators.integral): {
								expressionFragment.append(
									<mrow>
										<msubsup>
											{/* ∫ */}
											<mo>&#x222B;</mo>
											{recursiveRender(item.lowerLimit)}
											{recursiveRender(item.upperLimit)}
										</msubsup>
										{recursiveRender(item.integrand)}
										<mrow>
											<mo attr:rspace="0">d</mo>
											{recursiveRender(item.integrationVariable)}
										</mrow>
									</mrow>
								);
								break;
							}
							case (operators.plus): {
								expressionFragment.append(<mo>+</mo>);
								break;
							}
							case (operators.plusMinus): {
								expressionFragment.append(<mo>&#xB1;</mo>); // ±
								break;
							}
							case (operators.minus): {
								expressionFragment.append(<mo>&#x2212;</mo>); // −
								break;
							}
							case (operators.times): {
								expressionFragment.append(<mo>&#x22C5;</mo>); // ⋅
								break;
							}
							case (operators.divide): {
								expressionFragment.append(<mo>&#xF7;</mo>); // ÷
								break;
							}
							case (operators.colon): {
								expressionFragment.append(<mo>&#x2236;</mo>); // ∶
								break;
							}
							case (operators.invisibleTimes): {
								expressionFragment.append(<mo>&#x2062;</mo>);
								break;
							}
							case (operators.equals): {
								expressionFragment.append(<mo>=</mo>);
								break;
							}
							case (operators.lessThan): {
								expressionFragment.append(<mo>&lt;</mo>); // <
								break;
							}
							case (operators.greaterThan): {
								expressionFragment.append(<mo>&gt;</mo>); // >
								break;
							}
							case (operators.lessThanOrEqual): {
								expressionFragment.append(<mo>&#x2264;</mo>); // ≤
								break;
							}
							case (operators.greaterThanOrEqual): {
								expressionFragment.append(<mo>&#x2265;</mo>); // ≥
								break;
							}
							case (operators.doubleLeftArrow): {
								expressionFragment.append(<mo>&#x27F8;</mo>); // ⟸
								break;
							}
							case (operators.doubleRightArrow): {
								expressionFragment.append(<mo>&#x27F9;</mo>); // ⟹
								break;
							}
							case (operators.doubleLeftRightArrow): {
								expressionFragment.append(<mo>&#x27FA;</mo>); // ⟺
								break;
							}
						}

						break;
					}
					case (categories.keyword): {
						if (item.keywordName === keywords.pi) {
							expressionFragment.append(<mi>&pi;</mi>);
						}
						break;
					}
					case (categories.variable): {
						expressionFragment.append(<mi>{item.variable}</mi>);
						break;
					}
					case (categories.number): {
						expressionFragment.append(<mn>{item.number}</mn>);
						break;
					}
					case (categories.anyBracket): {
						expressionFragment.append(
							<mrow>
								<mo>
									{allBracketsSyntaxes.find(
										({ name, type }) => type === categories.anyOpeningBracket && name == item.anyBracketType
									).syntax}
								</mo>
								{recursiveRender(item.content)}
								<mo>
									{allBracketsSyntaxes.find(
										({ name, type }) => type === categories.anyClosingBracket && name == item.anyBracketType
									).syntax}
								</mo>
							</mrow>
						);
						break;
					}
					case (categories.function): {
						expressionFragment.append(
							<mrow>
								<mi>{item.functionName}</mi>
								<mo>{"("}</mo>
								{recursiveRender(item.parameters)}
								<mo>{")"}</mo>
							</mrow>
						);
						break;
					}
				}
			}

			if (expressionIndex >= 1) {
				const commaElement = <mo></mo>;
				commaElement.textContent = ",";
				fragment.append(commaElement);
			}

			fragment.append(
				(expression.length !== 1 && tree.length === 1 && !outerElement)
					? <mrow>{expressionFragment}</mrow>
					: expressionFragment
			);
			// fragment.append(expressionFragment);
		}

		// if (tree.length !== 1 && !outerElement) {
		// 	const mathRow = <mrow></mrow>;
		// 	mathRow.append(fragment);
		// 	return mathRow;
		// } else {
		// 	return fragment;
		// }
		return fragment;
	};

	return recursiveRender(mathTree, { outerElement: true });
};

